import { apiUrls } from '../../constants/apiUrls';
import { handlePromise } from '../helpers';

export const fetchUserDetails = async (headers = {}) => {
  const apiPayload = {
    method: 'GET',
    url: apiUrls.fetchUserDetailsAPI,
    headers: headers
  };

  return handlePromise(apiPayload);
};
